export default __webpack_public_path__ + "static/media/search-blue-bold.a6191f78.svg";